import { render, staticRenderFns } from "./TagBar.vue?vue&type=template&id=bae53e94&scoped=true"
import script from "./TagBar.vue?vue&type=script&lang=js"
export * from "./TagBar.vue?vue&type=script&lang=js"
import style0 from "./TagBar.vue?vue&type=style&index=0&id=bae53e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae53e94",
  null
  
)

export default component.exports